import { render, staticRenderFns } from "./ChartingWorkspaceSidebar.vue?vue&type=template&id=7a55800c&scoped=true&"
import script from "./ChartingWorkspaceSidebar.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceSidebar.vue?vue&type=style&index=0&id=7a55800c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55800c",
  null
  
)

export default component.exports